import { Home } from "./components/Home";
import { LogIn } from "./components/LogIn";
import { CustomerOverview } from "./components/CustomerOverview";
import { FileBrowser } from "./components/pages/FileBrowser";
import { FileUpload } from "./components/pages/FileUpload";
import { LogOut } from "./components/pages/LogOut";
import { SurveyApproval } from "./components/pages/SurveyApproval";
import { HammerTrak } from "./components/pages/HammerTrak";
import { HammerTrakPortal } from './components/pages/HammerTrakPortal';
import { Navigator } from './components/pages/Navigator';
import { AndroidUpdates } from "./components/pages/AndroidUpdates";
import { Mins } from './components/pages/Mins';
import { SteeringPage } from './components/pages/Steering';
import { UserManagement } from './components/pages/UserManagement';
import { ActivityLog } from './components/pages/ActivityLog';
import { AdminUserManagement } from './components/pages/AdminUserManagement';
import { AdminSettings } from './components/pages/AdminSettings';
import { AdminToolRuns } from './components/pages/AdminToolRuns';
import { Analysis } from './components/pages/Analysis';
import { Reports } from './components/pages/Reports';
import { Manuals } from './components/pages/Manuals';
import { RemoteViewer } from './components/pages/RemoteViewer';
import { Logs } from './components/pages/Logs';
import { BulkReview } from './components/pages/BulkReview';
import { ProtectedRoute } from './components/ProtectedRoute';

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/index',
        element: <Home />
    },
    {
        path: '/login',
        element: <LogIn />
    },
    {
        path: '/overview',
        element: <ProtectedRoute><CustomerOverview /></ProtectedRoute>
    },
    {
        path: '/files',
        element: <ProtectedRoute><FileBrowser /></ProtectedRoute>
    },
    {
        path: '/logout',
        element: <LogOut />
    },
    {
        path: '/upload',
        element: <ProtectedRoute><FileUpload /></ProtectedRoute>
    },
    {
        path: '/approval',
        element: <ProtectedRoute><SurveyApproval /></ProtectedRoute>
    },
    {
        path: '/bulk',
        element: <ProtectedRoute><BulkReview /></ProtectedRoute>
    },
    {
        path: '/hammertrak',
        element: <HammerTrak />
    },
    {
        path: 'hammertrak/portal',
        element: <ProtectedRoute><HammerTrakPortal /></ProtectedRoute>
    },
    {
        path: '/navigator',
        element: <Navigator />
    },
    {
        path: '/android',
        element: <AndroidUpdates />
    },
    {
        path: '/mins',
        element: <Mins />
    },
    {
        path: '/steering',
        element: <SteeringPage />
    },
    {
        path: '/users',
        element: <ProtectedRoute><UserManagement /></ProtectedRoute>
    },
    {
        path: '/activity',
        element: <ProtectedRoute><ActivityLog /></ProtectedRoute>
    },
    {
        path: '/admin/users',
        element: <ProtectedRoute><AdminUserManagement /></ProtectedRoute>
    },
    {
        path: '/admin/settings',
        element: <ProtectedRoute><AdminSettings /></ProtectedRoute>
    },
    {
        path: '/admin/tool-runs',
        element: <ProtectedRoute><AdminToolRuns /></ProtectedRoute>
    },
    {
        path: '/analysis',
        element: <ProtectedRoute><Analysis /></ProtectedRoute>
    },
    {
        path: '/reports',
        element: <Reports />
    },
    {
        path: '/manuals',
        element: <Manuals />
    },
    // Public by design: whoever is watching a rig's live toolface is usually not a DrillTrak
    // user, and the session code is what grants access. Like the downloads pages, it is
    // reachable by URL but not advertised in NavMenu. The second entry lets the operator send
    // a direct link rather than a code to type.
    {
        path: '/remote',
        element: <RemoteViewer />
    },
    {
        path: '/remote/:sessionId',
        element: <RemoteViewer />
    },
    {
        path: '/logs',
        element: <ProtectedRoute><Logs /></ProtectedRoute>
    }
];

export default AppRoutes;
